import React from 'react';
import CareerQuizEngine from './CareerQuizEngine';

const CareerSurvey = ({ quizData }) => {
    return (
        <CareerQuizEngine quizData={quizData} />
    );
};

export default CareerSurvey;
